import { Extension } from "../../core/extension";
import { SuggesterCallbacksRegistry, suggestPlugin, } from "../../core/suggest/suggest-plugin";
import { SlashCommandGroup, } from "../../core/types";
import { startMentionSuggester } from "./commands";
import { MemberSuggesterPluginView } from "./components/member-suggester";
import { RecordSuggesterPluginView } from "./components/record-suggester";
import { createMentionNodeSpec } from "./nodes";
import { openMentionDetailsOnClick, spaceAutoremovalPlugin } from "./plugins";
import { mentionSuggester } from "./suggesters";
import { MentionPrefix } from "./types";
export class MentionExtension extends Extension {
    constructor(mentionService) {
        super();
        this.mentionService = mentionService;
        this.memberSuggesterRegistry = new SuggesterCallbacksRegistry();
        this.recordSuggesterRegistry = new SuggesterCallbacksRegistry();
    }
    addNodes(nodes) {
        return nodes.append({
            mention: createMentionNodeSpec((attrs) => this.mentionService.isCurrentMember(attrs)),
        });
    }
    addSuggesters(suggesters) {
        return [
            ...suggesters,
            mentionSuggester("member-suggester", MentionPrefix.Member, this.memberSuggesterRegistry),
            mentionSuggester("record-suggester", MentionPrefix.Record, this.recordSuggesterRegistry),
        ];
    }
    addPlugins(schema, plugins, { portalContainer }) {
        return plugins.concat([
            openMentionDetailsOnClick(schema, this.mentionService),
            suggestPlugin(portalContainer, this.memberSuggesterRegistry, MemberSuggesterPluginView, {
                mentionService: this.mentionService,
                onPublicProfileOpen: (memberId, target) => this.mentionService.openPublicProfile(memberId, target),
            }),
            suggestPlugin(portalContainer, this.recordSuggesterRegistry, RecordSuggesterPluginView, {
                mentionService: this.mentionService,
            }),
            spaceAutoremovalPlugin(),
        ]);
    }
    addSlashCommands(commands) {
        return [
            ...commands,
            {
                label: `Mention a Person/Team`,
                description: `Mention a person or team to send them a notification`,
                group: SlashCommandGroup.Basics,
                icon: "is-user",
                command: (match, view) => {
                    startMentionSuggester(view, MentionPrefix.Member, match.range.from, match.range.to);
                },
            },
            {
                label: `Link to Record`,
                description: `Add a direct link to a table's record`,
                group: SlashCommandGroup.Basics,
                icon: "is-document",
                command: (match, view) => {
                    startMentionSuggester(view, MentionPrefix.Record, match.range.from, match.range.to);
                },
            },
        ];
    }
}
